// extracted by mini-css-extract-plugin
module.exports = {"root":"Skeleton_root__qVfYF","inDarkBg":"Skeleton_inDarkBg__T4GGG","fill":"Skeleton_fill__KAbnF","loading-skeleton":"Skeleton_loading-skeleton__fM8Vj"};